import type { DraftCustomerReportData } from '@dte/otw-azure-functions/src/common/interfaces/containers/draftCustomerReports/DraftCustomerReportData';
import { atom, useAtomValue } from 'jotai';
import { useSetAtomWithType } from '../../../../../../hooks/useSetAtomWithType';
import { locationPremiseIdAtom } from '../../questions/(nonPremise)/nonPremiseLocation/locationPremiseIdAtom';
import { draftReportAtom, storedDraftDataAtom } from './draftReportAtoms';

export function useDraftReport(): DraftCustomerReportData | undefined {
	return useAtomValue(draftReportAtom);
}

export function useReportPremiseId(): string | undefined {
	return useAtomValue(locationPremiseIdAtom);
}

const storedReportIdAtom = atom((get) => {
	const storedData = get(storedDraftDataAtom);
	return storedData?.draftReport?.reportId;
});
storedReportIdAtom.debugLabel = 'storedReportId';

function useStoredDraftReportId(): string | undefined {
	return useAtomValue(storedReportIdAtom);
}

export const reportSubmittedAtom = atom<boolean>((get) => {
	const storedDraftData = get(storedDraftDataAtom);
	return storedDraftData?.submittedReport !== undefined;
});

reportSubmittedAtom.debugLabel = 'reportSubmitted';

export function useIsDraftSubmitted(): boolean {
	return useAtomValue(reportSubmittedAtom);
}

export function useSetStoredDraftData() {
	return useSetAtomWithType(storedDraftDataAtom);
}

export const storedDraftReportAtom = atom((get) => {
	const storedData = get(storedDraftDataAtom);
	return storedData?.draftReport;
});
storedDraftReportAtom.debugLabel = 'storedDraftReport';
